import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import './index.css'
import App from './App.tsx'

// Google OAuth Client ID - configure via VITE_GOOGLE_CLIENT_ID env variable
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';
if (!GOOGLE_CLIENT_ID) {
  console.warn('VITE_GOOGLE_CLIENT_ID não configurado. Login com Google não funcionará.');
}

const AppWithProviders = () => (
  <StrictMode>
    {GOOGLE_CLIENT_ID ? (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    ) : (
      <App />
    )}
  </StrictMode>
);

/** Viewport + meta já limitam zoom no mobile; isso bloqueia Ctrl/Cmd+scroll e atalhos de zoom no desktop. */
function lockBrowserZoom(): void {
  document.addEventListener(
    'wheel',
    (e) => {
      if (e.ctrlKey) e.preventDefault();
    },
    { passive: false }
  );
  const zoomKeys = new Set([
    '+',
    '-',
    '=',
    '0',
    'NumpadAdd',
    'NumpadSubtract',
    'Numpad0',
  ]);
  document.addEventListener('keydown', (e) => {
    if (!e.ctrlKey && !e.metaKey) return;
    if (zoomKeys.has(e.key)) e.preventDefault();
  });
}

lockBrowserZoom();

createRoot(document.getElementById('root')!).render(<AppWithProviders />)

